import cn from 'classnames'
import React from 'react'

import styles from './SidebarNavigation.module.scss'

type SectionBarProps = React.HTMLAttributes<HTMLDivElement>

function SectionBar({ children, className }: React.PropsWithChildren<SectionBarProps>) {
  return <div className={cn(styles.section, className)}>{children}</div>
}

export default SectionBar
